"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransformationStage;
(function (TransformationStage) {
    TransformationStage["Initializing"] = "Initializing";
    TransformationStage["Preparing"] = "Preparing";
    TransformationStage["DeadCodeInjection"] = "DeadCodeInjection";
    TransformationStage["ControlFlowFlattening"] = "ControlFlowFlattening";
    TransformationStage["Converting"] = "Converting";
    TransformationStage["Obfuscating"] = "Obfuscating";
    TransformationStage["Finalizing"] = "Finalizing";
})(TransformationStage = exports.TransformationStage || (exports.TransformationStage = {}));
